import React from "react";
import { Switch, FormControlLabel } from "@material-ui/core";

import { rawTheme, themeOptions } from "styles/theme";
import { withStyles } from "@material-ui/core/styles";

const LabelledSwitch = withStyles((theme) => ({
    labelBase: {
        "& .MuiTypography-body1": {
            fontSize: "14px !important",
            fontStyle: "normal !important",
            fontWeight: "400 !important",
            lineHeight: "20px !important",
            color: `${themeOptions.palette.darkerGrey} !important`,
            fontFamily: "Lato, sans-serif !important",
        },
    },
    root: {
        width: 45,
        height: "1.91em",
        padding: 0,
        margin: rawTheme.spacing(1),
        overflow: "visible !important",
    },
    switchBase: {
        padding: "0.2em",
        "&$checked": {
            transform: "translateX(18px)",
            color: themeOptions.palette.white,
            "& + $track": {
                backgroundColor: "#00A39E",
                opacity: 1,
                border: "none",
            },
        },
        "&$focusVisible $thumb": {
            color: "#00A39E",
            border: "6px solid #fff",
        },
    },
    thumb: {
        width: 20,
        height: 20,
        boxShadow: "none",
    },
    track: {
        borderRadius: 100,
        backgroundColor: "#a2a3a3",
        opacity: 1,
        transition: theme.transitions.create(["background-color", "border"]),
    },
    checked: {},
    focusVisible: {},
}))(({
    classes,
    style,
    checked,
    onChange,
    label,
    dataTest = "",
    ...props
}: {
    classes: any;
    style: any;
    checked: boolean;
    onChange: any;
    label: string;
    dataTest: string;
    [key: string]: any;
}) => {
    return (
        <FormControlLabel
            className={classes.labelBase}
            control={
                <Switch
                    focusVisibleClassName={classes.focusVisible}
                    disableRipple
                    classes={{
                        root: classes.root,
                        switchBase: classes.switchBase,
                        thumb: classes.thumb,
                        track: classes.track,
                        checked: classes.checked,
                    }}
                    checked={!!checked}
                    onChange={onChange}
                    color={"primary"}
                    data-test={dataTest}
                />
            }
            label={label}
            {...props}
        />
    );
});

export default LabelledSwitch;
